/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TechList from '../../components/techSupports/TechList';
import { useNavigate } from 'react-router-dom';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import RsltTechSearchContainer from './RsltTechSearchContainer';
import { listRsltTechs } from '../../modules/techModule/techRslts';
import RsltStatusChip from '../../components/common/datagrid/RsltStatusChip';
import TechReqStatusChip from '../../components/common/datagrid/TechReqStatusChip';

const RsltTechListContainer = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { techs, error, loading } = useSelector(({ techModule, loading }) => ({
    techs: techModule.rsltTechs.techs,
    error: techModule.rsltTechs.error,
    loading: loading['tech/LIST_RSLT_TECHS'],
  }));

  useEffect(() => {
    dispatch(listRsltTechs());
  }, []);

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'reqUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'rsltUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },

      {
        field: 'prjUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'rsltStatus',
        headerName: '결재상태',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: RsltStatusChip
      },
      // {
      //   field: 'reqStatus',
      //   headerName: '작업상태',
      //   minWidth: 100,
      //   flex: 0.5,
      //   type: 'string',
      //   editable: false,
      //   align: 'center',
      //   headerAlign: 'center',
      //   renderCell: TechReqStatusChip,
      // },
      {
        field: 'rsltNo',
        headerName: '작업완료번호',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'rsltTyp',
        headerName: '종류',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'rsltTitle',
        headerName: '결과보고서명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'center',
      },
      {
        field: 'rsltStrtDt',
        headerName: '작업시작일',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => {
          return (params.value + " " + params.row.rsltStrtTm)
        }
      },

      {
        field: 'rsltEndDt',
        headerName: '작업종료일',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => {
          return (params.value + " " + params.row.rsltEndTm)
        }
      },
      {
        field: 'rsltTotTm',
        headerName: '작업시간',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => {
          return (params.value + " 시간")
        }
      },
      {
        field: 'crtNm',
        headerName: '작성자',
        minWidth: 80,
        flex: 0.3,
        type: 'string',
        align: 'center',
        headerAlign: 'center',
        editable: false,
      },
      {
        field: 'crtDt',
        headerName: '작성일',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        editable: false,
      },
    ],
    [],
  );

  const handleRowClick = (param, event) => {
    navigate(`/rslttechmng/${param.id}`)
  };

  return (
    <>
      <BreadcrumbsContainer title="기술지원/작업지원결과관리/결과 리스트" icon="tech" />
      <RsltTechSearchContainer />
      <TechList
        columns={columns}
        rows={techs}
        loading={loading}
        handleRowClick={handleRowClick}
      />
    </>
  );
};

export default RsltTechListContainer;
